import React from "react";
import DatePickerComponent from "../DatePickerComponent";

function AdmissionDischarge({
  dateOfAdmission,
  handleDateOfAdmissionChange,
  dischargeDate,
  handleDischargeDateChange,
  projectedResidentialDischargeDate,
  handleProjectedResidentialDischargeDateChange,
  projectedProgramCompletionDate,
  handleProjectedProgramCompletionDateChange,
}) {
  return (
    <div className="general-information-card general-information-admission-card">
      <div className="general-information-heading">
        <span className="general-information-kicker">Stay timeline</span>
        <h2>Admission &amp; Discharge</h2>
        <p>Actual and projected milestones for the client stay</p>
      </div>
      <div className="general-information-grid general-information-grid-dates">
        <DatePickerComponent
          title="Actual admission date"
          width="250px"
          value={dateOfAdmission}
          onChange={handleDateOfAdmissionChange}
        />
        <DatePickerComponent
          title="Actual discharge date"
          width={250}
          value={dischargeDate}
          onChange={handleDischargeDateChange}
        />
      </div>

      <div className="general-information-grid general-information-grid-dates">
        <DatePickerComponent
          title="Projected discharge date "
          width={250}
          value={projectedResidentialDischargeDate}
          onChange={handleProjectedResidentialDischargeDateChange}
        />

        <DatePickerComponent
          title="Projected aftercare completion date"
          width={250}
          value={projectedProgramCompletionDate}
          onChange={handleProjectedProgramCompletionDateChange}
        />
      </div>
    </div>
  );
}

export default AdmissionDischarge;
